module.exports = "/images/UnitedArabEmirates.png?000cbb4010553dfe1ef82b52425ab3cd";